import { writable } from 'svelte/store';
export const app_version = writable({
    app_name: 'Attal',
    version: '1.0.3' // !! Penser à modifier la version dans index.html !!!
});
export const storeDomain = writable("services");
export const storeIsOpenBurger = writable(false);
export const storeAnchorToLight = writable("");
export const storeIsIntro = writable(true);
// Premier affichage post intro. Sert à afficher ou non le fondu
export const storeIsFirstDisplay = writable(true);
export const storeScreenWidth = writable(0);
export const storeIsMobile = writable(false);
